import axios from 'axios';

export async function getPublicProfile(id) {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_SISAPI}/v2/acropolis/users/public-profile/${id}`
        );
        return response.data;
    } catch (error) {
        return { error };
    }
}

export async function getPublicProfileTeacher(id = 31442) {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_REPO}/v1/repo_aden/teacher/academic/${id}`
        );
        return response.data.response_data;
    } catch (error) {
        return { error };
    }
}
